import React from 'react'
import VerifyEmail from '../components/Mail/VerifyEmail'
import InstructorNavbar from '../components/instructor/InstructorNavbar'
import EditMarks from '../components/instructor/EditMarks'
// import EmailVerify from '../components/emailverification/Emailverify'

const EditMarksPage = () => {
  return (
    <div>
    <InstructorNavbar/>
    <EditMarks/>
    </div>
  )
}

export default EditMarksPage